import { Component, OnInit } from '@angular/core';
import { DoctorService } from '../../services/doctor.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-appointmentscreen',
  templateUrl: './appointmentscreen.component.html',
  styleUrls: ['./appointmentscreen.component.css']
})
export class AppointmentscreenComponent implements OnInit {
  st: any;
  start: number;
  no: any;
  allusers: any;
  pets: any;
  myclinic: any;
  spid: any;
  msg:any;
  action: any;
  appointment: any;
  walkin: any;
  timer1: any;
  timer2: any;
  str: any;
  selectedstatus: any;
  loading: any;
  array1= [];
  constructor(private doctorService: DoctorService, private router: Router,
  private route: ActivatedRoute, private snackbar: MatSnackBar) {
    this.route.params.subscribe(params => {
      this.spid = +params['id'];
    //  this.timer1 = setInterval(() => this.getTodaysAppointment(), 30000);
    //  this.timer2 = setInterval(() => this.getTodaysWalkin(), 30000);
    });
  /*  history.pushState(null, null, location.href);
    window.onpopstate = function () {
        history.go(1);
    };*/
  }

  ngOnInit() {
    this.getClinic();
    this.getTodaysAppointment();
    this.getTodaysWalkin();
  }
  getClinic() {
    this.doctorService.getMyTodaysClinic(this.spid)
    .subscribe(
      (x) => {
        this.myclinic = x;
      });
  }
  getTodaysAppointment() {
    this.doctorService.getTodaysAppointmentWithMe(this.spid)
    .subscribe(
      (b) => {
        this.appointment = b;
       this.getPetName();
      });
  }
  getPetName() {
    this.doctorService.getAllPets()
    .subscribe((x) => {
      this.pets = x;
      this.getAllDummyUsers();
    });
  }
  getAllDummyUsers() {
    this.doctorService.getAllDummyUser()
    .subscribe((x) => {
      this.allusers = x;
    });
  }

  getTodaysWalkin() {
    this.doctorService.getToaysWalkin(this.spid)
    .subscribe(
      (x) => {
        this.walkin = x;

      });
  }
  checkAppointtmentLength(id){
    if(this.appointment.length>0){
      for(let i = 0; i<this.appointment.length; i++){
        if(this.appointment[i].clinic_id == id){
          return true;
        }
      }
    } else {
      return false; 
    }
  }
  openSnackBar() {
    this.snackbar.open(this.msg , this.action,{
      duration: 4000,
    });
  }
  checkWalkinLength(id){
    if(this.walkin.length > 0){
      for(let i = 0; i < this.walkin.length; i++){
        if(this.walkin[i].clinic_id == id){
          return true;
        }
      }
    } else {
      return false;
    }
  }
  getNextAppointment(clid) {
    this.doctorService.getNextAppointment(clid, this.spid)
    .subscribe(
      (x) => {
        this.start = 1
        this.check(x);
      });
  }

  check(str) {
    this.str = str;
 this.st = this.str.substr(0, this.str.indexOf(' '));
 this.no = str.substr(str.indexOf(' ') + 1 );
 console.log(this.st);
 console.log(this.no);
  }

  updateStatus(cid, apid, status) {
    this.loading = true;
   this.doctorService.updateAppointmentStatus(apid, status)
    .subscribe((x) => {
      this.loading = false;
      this.msg = 'Appointment Status updated';
      this.openSnackBar();
      this.getTodaysAppointment();
      this.getTodaysWalkin();
      this.getNextAppointment(cid);
    });
  }

  updateClinicWalkinStatus(cid, apid, status) {
    this.loading = true;
   this.doctorService.updateClinicWalkinStatus(apid, status)
    .subscribe((x) => {
      this.loading = false;
      this.msg = 'Walkin Status updated';
      this.openSnackBar();
      this.getTodaysAppointment();
      this.getTodaysWalkin();
      this.getNextAppointment(cid);
    });
  }

  isNextWalkin(id, status) {
    var n = id.toString();
      if (this.no === n && this.st === status) {
        return true;
      } 
  }

  isNextAppointment(id, status) {
    var n = id.toString();
      if (this.no === n && this.st === status) {
        return true;
      } 
  }
}
